module.exports = __webpack_public_path__ + "static/media/Audioicon.e10c6409.svg";